module.exports = "/_next/static/Components/Solution/4275af3cbd936d672c5b3d14cf55a2f3.png";